export default "__VITE_ASSET__YHfXj5IA__"